/** Normalize a prior subject for follow-up: strip leading Re:/RE: and prepend "RE: ". */
export function followUpReplySubject(previousSubject: string): string {
  const trimmed = (previousSubject || '').trim();
  if (!trimmed) return 'RE: ';
  const withoutRe = trimmed.replace(/^(re|RE):\s*/i, '').trim();
  return `RE: ${withoutRe}`;
}
